/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Subject_Geography16Inputs */

const en__field_enum_subject_geography16 = /** @type {(inputs: _Field_Enum_Subject_Geography16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geography`)
};

const de__field_enum_subject_geography16 = /** @type {(inputs: _Field_Enum_Subject_Geography16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erdkunde / Geographie`)
};

/**
* | output |
* | --- |
* | "Geography" |
*
* @param {_Field_Enum_Subject_Geography16Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_subject_geography16 = /** @type {((inputs?: _Field_Enum_Subject_Geography16Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Subject_Geography16Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_subject_geography16(inputs)
	return de__field_enum_subject_geography16(inputs)
});
export { _field_enum_subject_geography16 as "_field_enum_SUBJECT_GEOGRAPHY" }